import { Bookmark } from 'lucide-react';
import { getAbstractAddress, getBlogAddress, getGoAddress, getGravatarImageFullURL } from '../../utils/PageAddressUtil';
import { formatDateStr } from '../../utils/DateUtil';

export default function PostCard({
    showPinned,
    pinned,
    blogDomainName,
    blogName,
    blogStatusOk,
    blogAdminMediumImageURL,
    link,
    title,
    description,
    publishedAt,
    linkAccessCount,
}) {
    const gravatarURL = getGravatarImageFullURL(blogAdminMediumImageURL);
    const blogURL = getBlogAddress(blogDomainName);
    const linkURL = getGoAddress(link);
    const abstractURL = getAbstractAddress(link);
    const publishedAtFormatted = formatDateStr(publishedAt);

    return (
        <div className="redesign-post-card">
            <div className="redesign-post-card-inner">
                <img className="redesign-post-icon" src={gravatarURL} alt="" />
                <div className="redesign-post-body">
                    <a
                        className="redesign-post-title"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={blogStatusOk ? linkURL : abstractURL}
                    >
                        {showPinned && pinned ? '📌 ' : ''}{title}
                    </a>
                    <div className="redesign-post-desc">{description}</div>
                    <div className="redesign-post-meta">
                        <a href={blogURL}>{blogName}</a>
                        <span>·</span>
                        <span>{publishedAtFormatted}</span>
                        <span>·</span>
                        <span>{linkAccessCount} 次阅读</span>
                    </div>
                </div>
                <div className="redesign-post-bookmark">
                    <Bookmark size={18} />
                </div>
            </div>
        </div>
    );
}
